import { route } from "preact-router";
import type { RoutableProps } from "preact-router";
import { confirmReviewEdit } from "../api";
import { ConfirmStatusView } from "../components/confirmStatusView";
import { useTokenConfirmation } from "../hooks/useTokenConfirmation";
import { toErrorPath, toThankYouPath } from "../routes";
import type { ConfirmReviewEditResponse, ErrorType } from "../types";

export function ConfirmEditScreen(_props: RoutableProps) {
  const error = useTokenConfirmation(
    confirmReviewEdit,
    (res: ConfirmReviewEditResponse) => {
      if (res.status === "ok") {
        route(
          toThankYouPath({
            firstName: res.firstName,
            companyName: res.companyName,
            rating: res.rating,
          }),
          true
        );
        return;
      }
      if (res.status === "already") {
        route(toThankYouPath({}), true);
        return;
      }
      route(toErrorPath(res.status as ErrorType), true);
    }
  );

  return <ConfirmStatusView error={error} />;
}
